import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import HeaderBgr from '../assets/header_bg.png';
import { InitState, LocalStorageText } from '../constants/common.js';
import AppProvider from 'contexts/AppContext';
import { useThemeContext } from 'contexts/ThemeContext';
import Snackbar from 'components/Snackbar';
import ConfirmDialog from 'components/ConfirmDialog';
import safeStorage from '../common/storage';

const styles = {
  headerBg: {
    maxWidth: '480px',
    width: '100%',
    position: 'fixed',
    top: 0,
  },
  borderLayout: {
    width: '100%',
    position: 'fixed',
    top: 0,
    height: '100%',
    maxWidth: '480px',
    boxShadow: '0 -3px 10px -3px #86868673',
  },
};
const token = safeStorage.getItem(LocalStorageText.Token);

if (!token) {
  safeStorage.setItem(LocalStorageText.Token, InitState);
}

const AppLayout = ({ children }) => {
  const token = safeStorage.getItem(LocalStorageText.Token);
  const [loginSuccess, setLoginSuccess] = useState(!!token);
  const location = useLocation();
  const { mainColor, defaultColor } = useThemeContext();

  // useEffect(() => {
  //   loginObservable.subscribe((token) => {
  //     setLoginSuccess(token !== InitState);
  //   });
  // });
  return (
    <AppProvider>
      <Snackbar />
      <ConfirmDialog />
      {mainColor === defaultColor ? (
        <img src={HeaderBgr} style={styles.headerBg} />
      ) : (
        <Box
          sx={{
            width: '100%',
            position: 'fixed',
            top: 0,
            backgroundColor: mainColor,
            height: '50%',
            WebkitMaskImage:
              '-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))',
            maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
          }}
          style={{ maxWidth: '480px' }}
        ></Box>
      )}
      <Box
        sx={{
          width: '100%',
          position: 'fixed',
          top: 0,
          height: '100%',
          maxWidth: '480px',
          boxShadow: '0 -3px 10px -3px #86868673',
        }}
      ></Box>
      <div style={{ position: 'relative' }}>
        <Header style={{ zIndex: '-999 !important' }} loginSuccess={true} />
        <main>{children}</main>
      </div>
      {location.pathname.split('/')[1] !== 'compulsory-moto' && (
        <Footer style={{ position: 'relative' }} />
      )}
    </AppProvider>
  );
};

export default AppLayout;
